let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8kZbl")).then(() => parcelRequire('3kT7K'));